import { useRedux } from 'hooks/index';
import {
    moduleAdminUpsert,
    moduleAdminViewAll,
    moduleAdminViewAllShort,
    moduleAdminViewDetails,
    moduleUserSetDefaultTab,
    moduleUserViewAll,
    moduleUserViewChapters,
    moduleUserViewDetails,
    moduleUserViewProgress,
    resetModule,
} from '../../redux/theory/module/actions';
import { ModuleNew } from '../../types/theory/module';

export default function useModule() {
    const { dispatch, appSelector } = useRedux();

    const { loading, apiUpsertSuccess, adminAllModules, adminAllModulesShort, adminModuleDetails, userAllModules, userModuleDetails, userModuleChapters, userDefaultTab, error } = appSelector(
        (state) => ({
            loading: state.ModuleTheory.loading,
            apiUpsertSuccess: state.ModuleTheory.apiUpsertSuccess,
            adminAllModules: state.ModuleTheory.adminAllModules,
            adminAllModulesShort: state.ModuleTheory.adminAllModulesShort,
            adminModuleDetails: state.ModuleTheory.adminModuleDetails,
            userAllModules: state.ModuleTheory.userAllModules,
            userModuleDetails: state.ModuleTheory.userModuleDetails,
            userModuleChapters: state.ModuleTheory.userModuleChapters,
            userDefaultTab: state.ModuleTheory.userDefaultTab,
            error: state.ModuleTheory.error,
        }),
    );

    const userLoadAllModules = () => {
        dispatch(moduleUserViewAll());
    };

    const userLoadModuleDetails = (slug: string) => {
        dispatch(moduleUserViewDetails(slug));
    };

    const userLoadModuleChapters = (slug: string) => {
        dispatch(moduleUserViewChapters(slug));
    };

    const userLoadModuleProgress = (slug: string) => {
        dispatch(moduleUserViewProgress(slug));
    };

    const userSetDefaultTab = (tab: string) => {
        dispatch(moduleUserSetDefaultTab(tab));
    };

    const userReset = () => {
        dispatch(resetModule());
    };

    const adminLoadAllModules = () => {
        dispatch(moduleAdminViewAll());
    };

    const adminLoadModuleDetails = (id: string) => {
        dispatch(moduleAdminViewDetails(id));
    };

    const adminUpsertModule = (data: ModuleNew) => {
        dispatch(moduleAdminUpsert(data));
    };

    const adminLoadAllModulesShort = () => {
        dispatch(moduleAdminViewAllShort());
    };

    return {
        adminAllModules,
        adminAllModulesShort,
        adminLoadAllModules,
        adminLoadAllModulesShort,
        adminLoadModuleDetails,
        adminModuleDetails,
        adminUpsertModule,
        apiUpsertSuccess,
        error,
        loading,
        userAllModules,
        userDefaultTab,
        userLoadAllModules,
        userLoadModuleChapters,
        userLoadModuleDetails,
        userLoadModuleProgress,
        userModuleChapters,
        userModuleDetails,
        userSetDefaultTab,
        userReset,
    };
}
